import moment from 'moment'
import {
  ICreated,
  DateRanges,
  IDateRange,
  DateRangeQueryParamsOptions,
} from '../types/date'
import { DATE_FORMATS } from '../config'

const getFormatByKey = (name: string, formats: any): string =>
  name && formats[name] ? formats[name] : formats.DEFAULT

export const calendar = (date: string, formatName = 'LONG'): string =>
  moment(date).calendar('', {
    sameDay: '[Today], HH:mm',
    nextDay: '[Tomorrow], HH:mm',
    nextWeek: 'dddd, HH:mm',
    lastDay: '[Yesterday], HH:mm',
    lastWeek: '[Last] dddd, HH:mm',
    sameElse: getFormatByKey(formatName, DATE_FORMATS),
  })

export const format = (date: string, formatName = 'LONG'): string =>
  moment(date).format(getFormatByKey(formatName, DATE_FORMATS))

export const timeAgo = (date: string): string => moment(date).fromNow()

export const timeDiff = (date: string): number => +new Date() - +new Date(date)

export const isToday = (date: string): boolean =>
  timeDiff(date) <= 24 * 60 * 60 * 1000

export const formatWithToday = (date: string): string =>
  isToday(date) ? timeAgo(date) : format(date, 'SHORT')

export const orderByCreatedDateAscending = (a: ICreated, b: ICreated): number =>
  +new Date(a.created) - +new Date(b.created)

export const applyDateRange = (from?: string, to?: string): DateRanges =>
  !(from && to)
    ? DateRanges.any
    : to === from
    ? DateRanges.on
    : DateRanges.between

export const getDateRange = (
  range: DateRanges,
  todayDate: string,
  nextMonth: string,
  from:
    | DateRangeQueryParamsOptions.dateFrom
    | DateRangeQueryParamsOptions.publishedFrom,
  to:
    | DateRangeQueryParamsOptions.dateTo
    | DateRangeQueryParamsOptions.publishedTo
): IDateRange => {
  switch (range) {
    case DateRanges.between:
      return { [from]: todayDate, [to]: nextMonth }
    case DateRanges.on:
      return { [from]: todayDate, [to]: todayDate }
    default:
      return { [from]: '', [to]: '' }
  }
}

export const getFormattedDateInUTC = (
  date: Date,
  fmt = DATE_FORMATS.SCHEDULE_FORM_FIELD
) => moment.utc(date).format(fmt)
